import dayjs from "dayjs";
import router from "../../router";
import services from "../services";

const strict = true;

const state = {
  step: 0,
  provinces: [],
  province: {},
  networkChoice: false,
  searchText: "",
  officesByProvince: [],
  officeByProvince: {},
  services: [],
  service: {},
  showNextSteps: false,
  bookableMonths: [],
  selectedMonth: {},
  selectedDay: null,
  selectedHour: null,
  selectedMinute: null,
  disableOffice: false,
  deliverRequestedService: false,
  offices: [],
  office: {},
  doctors: [],
  doctor: {},
  doctorName: "",
  date: "",
  pathology: "",
  userInfo: {},
  appointmentInfo: {},
  servicePrescription: "",
  contactChannelChanged: false,
  sendVoucherModeChanged: false
};

const getters = {
  step: state => state.step,
  getProvinces: state => state.provinces,
  getProvince: state => state.province,
  getNetworkChoice: state => state.networkChoice,
  getSearchText: state => state.searchText || "",
  getOfficesByProvince: state => state.officesByProvince,
  getOfficeByProvince: state => state.officeByProvince,
  getServices: state => state.services,
  getService: state => state.service,
  getShowNextSteps: state => state.showNextSteps,
  bookableMonths: state => state.bookableMonths,
  selectedMonth: state => state.selectedMonth,
  selectedHour: state => state.selectedHour,
  selectedMinute: state => state.selectedMinute,
  selectedDay: state => state.selectedDay,
  getDisableOffice: state => state.disableOffice,
  getDeliverRequestedService: state => state.deliverRequestedService,
  getOffices: state => state.offices,
  getOffice: state => state.office,
  getDoctors: state => state.doctors,
  getDoctor: state => state.doctor,
  getDoctorName: state => state.doctorName,
  getDate: state => state.date,
  getPathology: state => state.pathology,
  getUserInfo: state => state.userInfo,
  appointmentInfo: state => state.appointmentInfo,
  servicePrescription: state => state.servicePrescription,
  isContactChannelChanged: state => state.contactChannelChanged,
  isSendVoucherModeChanged: state => state.sendVoucherModeChanged
};

const mutations = {
  step(state, step) {
    state.step = step;
  },
  provinces(state, provinces) {
    state.provinces = provinces;
  },
  province(state, province) {
    if (state.province.code !== province.code) {
      state.province = province;
      state.networkChoice = false;
      state.searchText = "";
      state.officesByProvince = [];
      state.officeByProvince = {};
      state.services = [];
      state.service = {};
      state.showNextSteps = false;
      state.disableOffice = false;
      state.deliverRequestedService = false;
      state.bookableMonths = [];
      state.selectedMonth = {};
      state.offices = [];
      state.office = {};
      state.doctors = [];
      state.doctor = {};
      state.doctorName = "";
      state.selectedHour = null;
      state.selectedDay = null;
      state.selectedMinute = null;
    }
  },
  networkChoice(state, value) {
    state.networkChoice = value;
  },
  /**
   * @param {*} state
   * @param {*} offices
   * Sets the offices by province
   */
  officesByProvince(state, offices) {
    state.officesByProvince = offices;
  },
  /**
   * @param {*} state
   * @param {*} office
   * Sets the office selected
   */
  officeByProvince(state, office) {
    state.officeByProvince = office;
  },
  services(state, services) {
    state.services = services;
  },
  service(state, service) {
    state.service = service;
  },
  showNextSteps(state, value) {
    state.showNextSteps = value;
  },
  setServicePrescription(state, value) {
    state.servicePrescription = value;
  },
  bookableMonths(state, months) {
    state.bookableMonths = months;
  },
  selectedMonth(state, month) {
    state.selectedMonth = month;
    if (Object.keys(month).length > 0) {
      state.selectedMonth.notValidMsg = [];
    }
    // add message for month not covered if the selected month is not covered
    if (
      Object.keys(month).length > 0 &&
      (!month.covered || !month.originalCovered)
    ) {
      state.selectedMonth.notValidMsg.push("expost.monthNotCovered");
    }
    let province = state.province;
    let isNotAFullyCoveredProvince = !province?.fullyCovered || false;
    if (!isNotAFullyCoveredProvince) {
      state.offices = [];
      state.office = {};
      state.doctors = [];
      state.doctor = {};
      state.doctorName = "";
      state.disableOffice = false;
    } else {
      let officeByProvince = state.officeByProvince;
      // add message for month not covered for Sanimpresa only if the officeByProvince
      // is a Sanimpresa office and the selected month has not the SANI pacchetto
      if (
        officeByProvince &&
        officeByProvince?.sanimpresa &&
        month?.codicePacchetto?.length > 0 &&
        !month?.codicePacchetto?.includes("SANI")
      ) {
        state.selectedMonth.notValidMsg.push("expost.monthNotCoveredForSani");
      }
    }
  },
  selectedHour(state, hour) {
    state.selectedHour = hour;
  },
  selectedMinute(state, minute) {
    state.selectedMinute = minute;
  },
  selectedDay(state, day) {
    state.selectedDay = day;
  },
  disableOffice(state, value) {
    state.disableOffice = value;
  },
  deliverRequestedService(state, value) {
    state.deliverRequestedService = value;
  },
  offices(state, offices) {
    state.offices = offices;
  },
  office(state, office) {
    state.office = office;
  },
  doctors(state, doctors) {
    state.doctors = doctors;
  },
  doctor(state, doctor) {
    state.doctor = doctor;
  },
  doctorName(state, doctorName) {
    state.doctorName = doctorName ? doctorName.toUpperCase() : null;
  },
  date(state, date) {
    state.date = date;
  },
  selectedTime(state, time) {
    state.selectedTime = time;
  },
  pathology(state, pathology) {
    state.pathology = pathology;
  },
  userInfo(state, userInfo) {
    state.userInfo = userInfo;
  },
  appointmentInfo(state, info) {
    state.appointmentInfo = info;
  },
  reset(state) {
    state.provinces = [];
    state.province = {};
    state.networkChoice = false;
    state.searchText = "";
    state.officesByProvince = [];
    state.officeByProvince = {};
    state.services = [];
    state.service = {};
    state.showNextSteps = false;
    state.bookableMonths = [];
    state.selectedMonth = {};
    state.disableOffice = false;
    state.deliverRequestedService = false;
    state.offices = [];
    state.office = {};
    state.doctors = [];
    state.doctor = {};
    state.doctorName = "";
    state.date = "";
    state.pathology = "";
    state.userInfo = {};
    state.appointmentInfo = {};
  },
  setInitialStep(state, value) {
    state.step = Number(value);
  },
  resetStep0And1(state) {
    state.province = {};
    state.networkChoice = false;
    state.searchText = "";
    state.officesByProvince = [];
    state.officeByProvince = {};
    state.services = [];
    state.service = {};
    state.showNextSteps = false;
    state.bookableMonths = [];
    state.selectedMonth = {};
    state.disableOffice = false;
    state.deliverRequestedService = false;
    state.offices = [];
    state.office = {};
    state.doctors = [];
    state.doctor = {};
    state.doctorName = "";
  },
  resetStep1And2(state) {
    state.services = [];
    state.service = {};
    state.showNextSteps = false;
    state.bookableMonths = [];
    state.selectedMonth = {};
    state.disableOffice = false;
    state.deliverRequestedService = false;
    state.offices = [];
    state.office = {};
    state.doctors = [];
    state.doctor = {};
    state.doctorName = "";
    state.date = "";
    state.pathology = "";
  },
  setContactChannelChanged(state, value) {
    state.contactChannelChanged = value;
  },
  setSendVoucherModeChanged(state, value) {
    state.sendVoucherModeChanged = value;
  }
};

const actions = {
  async getAllProvinces({ commit, getters, rootGetters }) {
    try {
      commit("loading/openLoadingDialog", null, { root: true });
      let provinces = getters["getProvinces"];
      if (provinces && provinces.length === 0) {
        provinces = rootGetters["profile/allProvinces"];
        if (provinces && provinces.length === 0) {
          provinces = await services.bookingsService.getAllProvinces();
        }
      }
      commit("provinces", provinces);
    } catch (error) {
      commit("error/setError", error, { root: true });
    } finally {
      commit("loading/reset", null, { root: true });
    }
  },
  /**
   * Gets and commits the offices by province returned by the service
   */
  async getOfficesByProvince({ commit, getters, rootGetters }, toSearch) {
    try {
      commit("loading/openLoadingDialog", null, {
        root: true
      });
      let searchQuery = toSearch ? toSearch.replace(/([^-]* - )/g, "") : "";
      let provinceCode = getters["getProvince"].code;
      let isSanimpresaMember =
        rootGetters["coverages/isSanimpresaMemberForCoverage"] || false;
      let payload = {
        toSearch: searchQuery,
        provinceCode: provinceCode,
        isSanimpresaMember: isSanimpresaMember
      };
      let offices = await services.bookingsService.getOfficesByProvince(
        payload
      );
      offices = sortByKey(offices, "legalName");
      commit("officesByProvince", offices);
    } catch (error) {
      commit("error/setError", error, { root: true });
    } finally {
      commit("loading/reset", null, { root: true });
    }
  },
  async setOfficeByProvince({ commit }, office) {
    commit("officeByProvince", office);
    commit("step", 2);
  },
  async getServices(
    { commit, getters, dispatch, rootGetters },
    { search, autocomplete }
  ) {
    try {
      commit("showNextSteps", false);
      let searchQuery = search ? search : "";
      if (searchQuery.length >= 3) {
        commit("service", {});
        commit("disableOffice", false);
        commit("offices", []);
        commit("office", {});
        commit("doctors", []);
        commit("doctor", {});
        commit("setServicePrescription", "");
        commit("pathology", "");
        let isSanimpresaMember =
          rootGetters["coverages/isSanimpresaMemberForCoverage"] || false;
        let res = await services.bookingsService.getServiceNames({
          search: searchQuery,
          provinceCode: getters["getProvince"].code,
          includeAliases: false,
          isSanimpresaMember: isSanimpresaMember
        });
        commit("services", sortByKey(res, "nameByLang"));
        if (!autocomplete) {
          commit("loading/openLoadingDialog", null, { root: true });
          let selected = null;
          if (res.length === 1) {
            selected = res[0];
          } else {
            selected = res.find(s => searchQuery === s.nameByLang);
          }
          let province = getters["getProvince"];
          let isNotAFullyCoveredProvince = !province?.fullyCovered || false;
          let payload = {
            serviceId: selected.serviceId,
            provinceCode: province?.code || null,
            ancillaryIds: []
          };
          let service = await services.bookingsService.getServiceWithId(
            payload
          );
          service.nameByLang = selected.nameByLang;
          commit("service", service);
          commit("selectedMonth", {});
          await dispatch("calculateBookableMonthsWithBasedCriteria");
          commit("deliverRequestedService", false);
          commit("disableOffice", true);
          commit("offices", []);
          commit("office", {});
          commit("doctors", []);
          commit("doctor", {});
          commit("setServicePrescription", "");
          commit("pathology", "");
          commit("selectedHour", null);
          commit("selectedMinute", null);
          commit("selectedDay", null);
          if (isNotAFullyCoveredProvince) {
            await dispatch("searchOfficeByProvinceForServiceId");
          }
          commit("showNextSteps", true);
        }
      } else {
        commit("disableOffice", true);
        commit("services", []);
      }
    } catch (error) {
      commit("error/setError", error, { root: true });
    } finally {
      commit("loading/reset", null, { root: true });
    }
  },
  async searchOfficeByProvinceForServiceId({ commit, getters }) {
    try {
      commit("loading/openLoadingDialog", null, { root: true });
      let province = getters["getProvince"];
      let isNotAFullyCoveredProvince = !province?.fullyCovered || false;
      let selectedMonth = getters["selectedMonth"];
      let officeByProvince = getters["getOfficeByProvince"];
      let isSanimpresaMember = isNotAFullyCoveredProvince
        ? officeByProvince?.sanimpresa
        : selectedMonth
        ? selectedMonth?.codicePacchetto
          ? selectedMonth?.codicePacchetto.length > 0
            ? selectedMonth?.codicePacchetto.includes("SANI")
            : false
          : false
        : false;
      let offices = await services.bookingsService.getOfficesNameByKey({
        serviceId: getters["getService"].serviceId,
        province: getters["getProvince"].code,
        obese: false,
        claustrophobia: false,
        toSearch: getters["getOfficeByProvince"].legalName,
        isSanimpresaMember: isSanimpresaMember
      });
      offices = offices.filter(office => office.deliverRequestedService);
      let found = offices.find(
        off => off.officeId === officeByProvince.officeId
      );
      if (found) {
        commit("disableOffice", true);
        commit("deliverRequestedService", true);
        commit("offices", sortByKey(offices, "legalName"));
        commit("office", found);
        commit("doctors", []);
        commit("doctor", {});
      } else {
        commit("disableOffice", false);
        commit("deliverRequestedService", false);
        commit("offices", []);
        commit("office", {});
      }
    } catch (error) {
      commit("error/setError", error, { root: true });
    } finally {
      commit("loading/reset", null, { root: true });
    }
  },
  async getOffices({ commit, getters }, { search, autocomplete }) {
    try {
      let offices = [];
      let searchQuery = search ? search.replace(/ \([^)]*\)/g, "") : "";
      if (searchQuery.length >= 3) {
        commit("disableOffice", false);
        let selectedMonth = getters["selectedMonth"];
        let isSanimpresaMember = selectedMonth
          ? selectedMonth?.codicePacchetto
            ? selectedMonth?.codicePacchetto.length > 0
              ? selectedMonth?.codicePacchetto.includes("SANI")
              : false
            : false
          : false;
        offices = await services.bookingsService.getOfficesNameByKey({
          serviceId: getters["getService"].serviceId,
          province: getters["getProvince"].code,
          obese: false,
          claustrophobia: false,
          toSearch: searchQuery,
          isSanimpresaMember: isSanimpresaMember
        });
        offices = offices.filter(office => office.deliverRequestedService);
        commit("offices", sortByKey(offices, "legalName"));
      }
      if (!autocomplete) {
        commit("loading/openLoadingDialog", null, { root: true });
        offices = offices.filter(office => office.legalName === searchQuery);
        commit("office", offices[0]);
        commit("doctors", []);
        commit("doctor", {});
      }
    } catch (error) {
      commit("error/setError", error, { root: true });
    } finally {
      commit("loading/reset", null, { root: true });
    }
  },
  async getDoctors({ commit, getters }, { search, autocomplete }) {
    try {
      let doctors =
        await services.bookingsService.callGetDoctorsByOfficeService({
          officeServiceId: getters["getOffice"].officeServiceId
        });
      doctors = sortByKey(
        doctors.filter(doc =>
          `${doc.doctorName} ${doc.doctorSurName}`
            .toLowerCase()
            .includes(search.toLowerCase())
        ),
        "doctorName"
      );
      let noDoctorObj = {
        doctorId: "fake-doctor-id",
        doctorName: "Non selezionabile",
        doctorSurName: "",
        officeId: "fake-office-id"
      };
      doctors.unshift(noDoctorObj);
      commit("doctors", doctors);
      if (!autocomplete) {
        commit("doctor", doctors[0]);
      }
    } catch (error) {
      commit("error/setError", error, { root: true });
    }
  },
  initializeWithAppointment({ commit }, appointment) {
    try {
      if (appointment) {
        commit("province", /*appointment.province ||*/ {});
        commit("service", /*appointment.service ||*/ {});
        commit("pathology", /*appointment.pathology ||*/ "");
        commit("office", /*appointment.office ||*/ {});
        commit("bookableMonths", /*appointment.bookableMonths ||*/ []);
        router.push({ name: "expost" });
      }
    } catch (error) {
      console.error(error);
    }
  },
  /**
   * Changes preferred contact channel in userInfo
   */
  async changePreferredContactChannel({ commit, getters }, channel) {
    let userInfo = { ...getters["getUserInfo"] };
    userInfo.preferenzaContatto = channel;
    commit("userInfo", userInfo);
    commit("setContactChannelChanged", true);
  },
  /**
   * Changes vouFcher mode in userInfo
   */
  async changeSendVoucherMode({ commit, getters }, voucherMode) {
    let userInfo = { ...getters["getUserInfo"] };
    userInfo.modalitaInvioVoucher = voucherMode;
    commit("userInfo", userInfo);
    commit("setSendVoucherModeChanged", true);
  },
  async createExpost({ commit, getters, dispatch }) {
    commit("loading/openLoadingDialog", null, { root: true });
    let date = dayjs(getters["getDate"]).format("YYYY-MM-DD");
    let hour = dayjs(getters["getDate"]).hour();
    let minute = dayjs(getters["getDate"]).minute();
    let dateTime = dayjs(`${date}T${hour}:${minute}`).format();
    let userInfo = { ...getters["getUserInfo"] };
    let channel = userInfo.preferenzaContatto;
    let voucherMode = userInfo.modalitaInvioVoucher;
    let voucherChannelType = "NONE";
    if (voucherMode == "M") {
      voucherChannelType = "MAIL";
    } else if (voucherMode == "C") {
      voucherChannelType = "MAIL_ENCRYPTED";
    } else if (voucherMode == "S") {
      voucherChannelType = "SHORT_SMS";
    } else if (voucherMode == "L") {
      voucherChannelType = "LONG_SMS";
    }
    let voucherContact = {
      email: userInfo.email3,
      phone: userInfo.telefono3,
      voucherChannelType
    };
    let doctorFullName = null;
    const isVsp = getters["getService"]?.macroArea === "VSP";
    const isFakeId = getters["getDoctor"].doctorId === "fake-doctor-id";
    const doctorName = getters["getDoctorName"];
    if (!isVsp || !isFakeId) {
      doctorFullName = null;
    } else {
      //always required
      doctorFullName = doctorName;
    }
    let appointment = {
      province: getters["getProvince"],
      voucherContact,
      serviceId: getters["getService"].serviceId,
      hfOfficeId: getters["getOffice"].officeId,
      appointmentType: "EXPOST",
      pathology: getters["getPathology"],
      appointmentDate: dateTime,
      doctorId:
        getters["getDoctor"].doctorId === "fake-doctor-id"
          ? null
          : getters["getDoctor"].doctorId,
      prestazioneInPrescrizione: getters["servicePrescription"],
      doctorFullName: doctorFullName
    };
    try {
      let isContactChannelChanged = getters["isContactChannelChanged"];
      if (isContactChannelChanged) {
        await dispatch("profile/changePreferredContactChannel", channel, {
          root: true
        });
      }
      let isSendVoucherModeChanged = getters["isSendVoucherModeChanged"];
      if (isSendVoucherModeChanged) {
        await dispatch("profile/changeSendVoucherMode", voucherMode, {
          root: true
        });
      }
      commit("loading/openLoadingDialog", null, { root: true });
      let res = await services.appointmentService.createExpostAppointment(
        appointment
      );
      commit("appointmentInfo", res);
      commit("step", 4);
    } catch (error) {
      error.callback = function () {
        router.push({ name: "profile" });
      };
      commit("error/setError", error, { root: true });
    } finally {
      commit("loading/reset", null, { root: true });
    }
  },
  async calculateBookableMonthsWithBasedCriteria({
    commit,
    getters,
    rootGetters
  }) {
    try {
      commit("loading/openLoadingDialog", null, { root: true });
      let bookableMonths = [];
      let service = getters["getService"];
      let bookingInfo = await services.coverageService.getServiceBookingInfo({
        id: service.serviceId,
        memberFiscalCode: rootGetters["login/userInfo"].codiceFiscale
      });
      // Check this year's coverage
      if (Object.keys(bookingInfo).length) {
        let thisYear = dayjs().year();
        bookingInfo[`${thisYear}`].coverage = bookingInfo[
          `${thisYear}`
        ].coverage.map(coverage => ({
          originalCovered:
            !coverage.notCovered && coverage.codicePacchetto.includes("FE1"),
          covered:
            !coverage.notCovered &&
            coverage.bookableByRule &&
            !coverage.maxCeilingReached &&
            !coverage.maxHealthCareReached &&
            coverage.codicePacchetto.includes("FE1"),
          codicePacchetto: coverage.codicePacchetto,
          year: `${thisYear}`,
          month: coverage.month,
          healthCareResidual: !coverage.notCovered
            ? coverage.healthCareResidual
            : -1,
          notValidMsg: []
        }));
        if (bookingInfo[`${thisYear}`].coverage.length) {
          bookableMonths.push(...bookingInfo[`${thisYear}`].coverage);
        }
        // Check next year's coverage
        let nextYear = bookingInfo[`${thisYear + 1}`];
        if (nextYear) {
          nextYear.coverage = nextYear.coverage.map(coverage => ({
            originalCovered:
              !coverage.notCovered && coverage.codicePacchetto.includes("FE1"),
            covered:
              !coverage.notCovered &&
              coverage.bookableByRule &&
              !coverage.maxCeilingReached &&
              !coverage.maxHealthCareReached &&
              coverage.codicePacchetto.includes("FE1"),
            codicePacchetto: coverage.codicePacchetto,
            year: `${thisYear + 1}`,
            month: coverage.month,
            healthCareResidual: !coverage.notCovered
              ? coverage.healthCareResidual
              : -1,
            notValidMsg: []
          }));
          if (nextYear.coverage.length) {
            bookableMonths.push(...nextYear.coverage);
          }
        }
      }
      commit("bookableMonths", bookableMonths);
      return;
    } catch (error) {
      console.error(error);
    } finally {
      commit("loading/reset", null, { root: true });
    }
  }
};

const sortByKey = (array, key, order) => {
  if (order === "asc" || !order) {
    return array.sort((a, b) => {
      let aVal = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
      let bVal = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];
      if (aVal < bVal) return -1;
      else if (aVal > bVal) return 1;
      else return 0;
    });
  } else {
    return array.sort((a, b) => {
      let aVal = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
      let bVal = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];
      if (aVal < bVal) return 1;
      else if (aVal > bVal) return -1;
      else return 0;
    });
  }
};

export default {
  strict,
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
